import {
  StoreLocatorConfigData,
  StoreLocatorRequestData,
  StoreLocatorTextResources,
} from './StoreLocatorConfiguration';

export const DefaultConfigData: StoreLocatorConfigData = {
  keyaccount: 6822,
  countrycode: 'de_DE',
  latitude: 48.4,
  longitude: 8.2,
  mapzoom: 6,
  onsiteprinter: 1, // 1 or 0
};

export const DefaultRequestData: StoreLocatorRequestData = {
  init: {
    keyacc_id: DefaultConfigData.keyaccount,
    client_id: 9,
    client_version: '1.1.0',
    client_name: 'COPS',
    locale: DefaultConfigData.countrycode,
  },
  hello: {
    server_protocol: '2.3',
  },
  location: {
    onsite_printer_only: DefaultConfigData.onsiteprinter,
  },
};

export const DefaultTextResources: StoreLocatorTextResources = {
  error: {
    server: 'Error: Server connection failed.',
    location: 'Error: Location not found.',
    icon: 'Error: Icon could not be loaded.',
    distance: 'Error: Distance could not be calculated.',
    geolocation_service: 'Error: The Geolocation service failed.',
    geolocation_support: "Error: Your browser doesn't support geolocation.",
    feature_not_available: 'Error: This feature is currently not available.',
  },
  control: {
    search: 'Search store by zip code or city',
    zoom_in: 'Zoom In',
    zoom_out: 'Zoom Out',
    current_location: 'Pan to current location',
    search_box_onsite_printer_only: 'CEWE Photostation available',
  },
  filter: {
    headline: 'Filter by Product',
    photos: 'Instant photos (up to 15 x 20 cm)',
    posters: 'Instant poster (up to 20 x 30 cm)',
    stickers: 'Instant stickers',
    search_button: 'Search',
    search_field: 'Search by product name',
    keys: 'Accepted keys',
    filter_open: 'Open Stores',
    filter_distance: 'Sort by Distance',
    filter_reset: 'Reset Filters',
    stores_found: 'stores found',
    store_found: 'store found',
    not_found: 'no store found',
    not_found_slider: 'No store found for your search criteria !',
    nothing_to_filter: 'nothing to filter',
  },
  weekdays: {
    Mo: 'Monday',
    Tu: 'Tuesday',
    We: 'Wednesday',
    Th: 'Thursday',
    Fr: 'Friday',
    Sa: 'Saturday',
    Su: 'Sunday',
  },
  location: {
    control: {
      back: 'back',
      back_results: 'Back to the results',
      widget_show: 'Show side control panel',
      widget_hide: 'Hide side control panel',
      img_show_more: 'View all photos',
      img_show_less: 'Show less',
      calculate_route: 'Calculate route',
      order_now: 'Order now',
      get_directions: 'Get Directions',
    },

    route_to_station: 'Route to the CEWE photo station',
    start_time: 'Start Time',
    show_more: 'More CEWE photo stations',
    more_info: 'More info',
    distance: 'away',
    opening_hours: 'Our Opening Hours',
    onsite_products: 'Our products on site',
    products_variety: 'Our product variety',
    open_soon: 'open soon',
    opens_at: 'opens at',
    close_soon: 'close soon',
    closes_at: 'closes at',
    status_open: 'Open',
    status_closed: 'Closed',
    cover_image:
      'cdn/images/cw/4w/cW4wVnU1QXpuem9GdUlWbVdCZG9UZ2trdlRnODIwL1RmL2RVRUJ1TUhKREVmVzZSa2dNckRNcVRNQlMzL2RJR0U5SU8vbTIweHo4MUx3R0MyTXhrMEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
    default_pin:
      'cdn/images/wh/dw/WHdwZUgrMFZsZk9zdnhjK1lJaGtoTWJuSDVIL2NUdVA4dDYrdC8vS1F3bk5KVzFSazhzRjFsSVc2b1FEZm9nRzN2amprWmk0OEVJVEU5TTJUTXFwQVVOaHJsakZzWTV3ZWpKZjN5UXVMM1E9',
  },
  productData: {
    photos: {
      headline: 'Instant photos',
      description:
        'Print photos directly from your smartphone or common storage media in brilliant quality on high-quality photo paper.',
      images: {
        0: 'cdn/images/cm/dr/cmdrWUkzY3pQbmJVSVBYQXc2S3IyY2xlVUlPSFlQK0dVUDlDcC9hZ0hoWG1tV0xLVUtTNVhxWldjSnJWRWhJOXBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [8466, 8467, 8468, 8621, 8622, 8623, 8647, 8992, 8466, 8468, 8992] /* eslint-disable-line no-magic-numbers */,
    },
    poster: {
      headline: 'Instant poster (20 x 20 cm, 20 x 30 cm)',
      description: '',
      images: {
        0: 'cdn/images/vu/iw/VUIweGQ1NTV4NTBzZEMxdm8xY1MybHBjMzdGakR0OFRCMTczZlU5TlNvTkVQQzZFejVISUs2V0VGa29yUlhDVHBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [8599, 8718, 8719, 8720, 8721, 8722, 7391] /* eslint-disable-line no-magic-numbers */,
    },
    photos_frame: {
      headline: 'Instant photos with frame/text/design',
      description: '',
      images: {
        0: 'cdn/images/qu/zm/QUZMNGdldjFvT3YxbmZPZnJZTjhqQVV6VWdhK0N3UmZKdUtFZ0QxWmNvbzhrZitNb3EvMDVVeUhJSnNsZFcyVnBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
        1: 'cdn/images/c3/pm/c3pmWTB1cVB5SkdJUndCeUxGR0dMY04yWVY0bGVUUVdsYUFkV0lTQlZoVHpNZkhTWTk5R1FaTStqVE0waFZuV3BQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
        2: 'cdn/images/ou/tn/OUtnbWpHaGIzUmVLS0N3YnIrMGw0MEVSKzdGUmNYcXZadlFFcmNYMk10OXErVVhKSkdqRG1FaDN1RXFIWlZpT3BQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [7162, 7163, 7164] /* eslint-disable-line no-magic-numbers */,
    },
    photos_strip: {
      headline: 'Instant photo strips',
      description: '',
      images: {
        0: 'cdn/images/rv/rm/RVRmTlZiTDBwQ1FEYmQ3dGRXZE5WWTMvVGlrZnlsNTRXcEJmaTFkck5xQXpMV1U0WXhQdkJMMGJjZ3RxRWxnWXBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [7161] /* eslint-disable-line no-magic-numbers */,
    },
    greeting_cards: {
      headline: 'Instant photo greeting cards',
      description: '',
      images: {
        0: 'cdn/images/y0/d4/Y0d4Y2EzbXplN1BMNlkxUzBCV05ZbnRuK2hKTEQ3Slc3d2VQYUNUWXdHZzh3ck9WSFVDVWFBT003ZHdicWRoQ3BQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [8604, 8605, 8606, 8994] /* eslint-disable-line no-magic-numbers */,
    },
    collages: {
      headline: 'Instant collages',
      description: '',
      images: {
        0: 'cdn/images/nx/lj/NXlJanA1bEF4YzhSTk5qMVI2Z1pycCtaVnlKUUdmeXVqNFZ1MUFZOGVUSVREazdoRDlQZjRjb2NvbDhVYzFiZ3BQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [8602, 8603, 8723, 8724, 8725, 8726, 8727, 7392] /* eslint-disable-line no-magic-numbers */,
    },
    photo_sets: {
      headline: 'Instant photo sets',
      description: '',
      images: {
        0: 'cdn/images/ed/zb/eDZBMnpPRHo1eS8ycTFudTlvaGF5YURDQ093NjEvM2VPcWoxN29idDdZbjFsWDdINTZCWWtFOXFBVmE0UTI3ZXBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [8600, 8607, 8608, 8609, 8649, 7002] /* eslint-disable-line no-magic-numbers */,
    },
    multipart_photos: {
      headline: 'Multi-part instant photos',
      description: '',
      images: {
        0: 'cdn/images/ug/xi/UGxiVWxuSS92dXVGMXAvRDQwL1BNNm9mZXlPVjB6cXBXSTJ2MzgzT0JtSW80dnZVK1VKTUtCMzRYQzVvMTQ1RXBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [8601] /* eslint-disable-line no-magic-numbers */,
    },
    stickers: {
      headline: 'Instant stickers',
      description:
        'Self-adhesive stickers that can be designed with your own photos and various design templates. Also available as cell phone stickers or for customizing gift cards.',
      images: {
        0: 'cdn/images/cn/fm/cnFmWXV3WUJyT0NDcnpnRUc4OGRDMG9WT3JaSVh3VUFSWE5NcEh0OGVKMUdWUG91U3ZYOEordjhDbzhlY1haUHBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [7238, 7236, 7204] /* eslint-disable-line no-magic-numbers */,
    },
    product_labels: {
      headline: 'Instant product labels',
      description: 'Self-adhesive product labels that you can design with your own photos.',
      images: {
        0: 'cdn/images/wg/pp/WGpPVjdyODd0STM1dGxYaFhYK3V6TmJqYVVNbzhRZDJ2cEtvaDhGQkdSM2thUjMwd1g0QllCYndSdFlaU2VabHBQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [7239, 7237, 7205] /* eslint-disable-line no-magic-numbers */,
    },
    canvas: {
      headline: 'Instant canvas',
      description: '',
      images: {
        0: 'cdn/images/ww/5e/WW5EbVhzdFYwTnEzamRBMnh6cDd6a3NINTlweVNRZG55Z0lYWnBqQWRQVUxENnR4UHBxNnlObFVERFpZS1dNQ3BQMktXZlFVb1RnekVkNzlDcVBWZEtvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [7769, 7770, 7771] /* eslint-disable-line no-magic-numbers */,
    },
    retro_minis: {
      headline: 'Instant retro minis',
      description: '',
      images: {
        0: 'cdn/images/sz/jm/SzJMRXNjM3h1QmhsV0ozeEMralJhU0ZubW5ab1pSUGtjVzhaaE1zblNuSFlXWkRSRENxQUcyOUpRZ1BrcWx0bVBaZ2IzUzYwR1JmdEhKdDFjL0haVzZvRDdvejZGNHJrVXFOMHlpS0tjVGM9',
      },
      productid: [6563] /* eslint-disable-line no-magic-numbers */,
    },
    passfoto: {
      headline: 'Instant passfoto',
      description: '',
      images: {
        0: '',
      },
      productid: [6855, 6856] /* eslint-disable-line no-magic-numbers */,
    },
  },
};
